export interface IMTempCondition {
  amountOfDays: number,
  units: string,
  temperatureFrom: number,
  temperatureTo: number,
}
